// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StoreSwitcher{list-style:none;display:flex;border-left:1px solid #D9D9D9;margin-left:auto}\n", ""]);
// Exports
module.exports = exports;
